import styled from 'styled-components'
import { Color } from '~/shared/constants/uiConstants'

export type TWrapperProps = {
  marginBottom: number
}

export type TInputProps = {
  inputHeight: number
}

export const StyledInput = {
  Wrapper: styled.div<TWrapperProps>`
    position: relative;
    width: 100%;
    margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};

    &[data-valid='false'] input {
      outline: 1px solid ${Color.RED_500};
    }

    &::after {
      display: block;
      width: calc(100% - 32px);
      color: ${Color.RED_500};
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
      margin-top: 4px;
      margin-inline-start: 16px;
    }

    &[data-valid='false']::after {
      content: attr(data-validation-text);
    }
  `,
  Input: styled.input<TInputProps>`
    width: 100%;
    height: ${({ inputHeight }) => `${inputHeight}px`};
    padding: 20px 16px;
    border-radius: 16px;
    background: ${({ theme }) => theme.colors.inputBackground};
    outline: ${({ theme }) => theme.common.emailInputOutline};
    border: none;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    font-size: 17px;
    font-weight: 400;
    line-height: 24px;
    transition: border 0.2s ease-out;
    /* email/password/card fields are always Latin content — keep them LTR
       even on an rtl page (dir prop defaults to 'ltr' in Input.tsx) */
    direction: ltr;
    text-align: left;
  `,
  Label: styled.label`
    display: block;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.hintColor};
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.5px;
  `,
}
